export enum VpcTypes {
    New = 'New',
    Existing = 'Existing',
    Shared = 'Shared'
}
